import { useTranslation } from "react-i18next";

export default function SomethingWrong() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white dark:bg-black">
      <span className="text-[100px] font-extrabold normal-case text-[#030C10] dark:text-white mb-0">
        {t("errors.oops")}
      </span>

      <div className="flex gap-1 flex-col justify-center items-center text-center mt-8">
        <span className="text-black dark:text-white normal-case text-xl font-bold">
          {t("errors.errorMSG1")}
        </span>
        <div>
          <span className="text-sm text-[#989898] ">
            {t("errors.errorMSG2")}
          </span>
          <span className="flex gap-1 text-sm text-[#989898] justify-center items-center text-center">
            {t("errors.errorMSG3")}
            <a href="/" className="underline">
              {t("errors.errorMSG4")}
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}
